/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import type { CalendarEvent } from '@services/requests/housien-models/CalendarEvent';

/**
 * Returns true when the event represents a projected visit.
 * Visit events have either an explicit `visit_id` field or an `event_id`
 * prefixed with `visit:`.
 */
export const isVisitEvent = (event: Pick<CalendarEvent, 'event_id' | 'visit_id'>): boolean =>
  Boolean(event.visit_id) || event.event_id.startsWith('visit:');

/**
 * Extracts the visit ID from an event that represents a visit.
 * Returns undefined if the event is not a visit event.
 */
export const extractVisitId = (event: Pick<CalendarEvent, 'event_id' | 'visit_id'>): string | undefined => {
  if (event.visit_id) return event.visit_id;
  if (event.event_id.startsWith('visit:')) return event.event_id.slice('visit:'.length);
  return undefined;
};
